import React, { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import ArtworkCard from '@/components/ArtworkCard';
import { Button } from '@/components/ui/button';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export default function GalleryPage() {
  const [artworks, setArtworks] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchParams, setSearchParams] = useSearchParams();
  const category = searchParams.get('category') || 'all';

  useEffect(() => {
    fetchArtworks();
  }, [category]);

  const fetchArtworks = async () => {
    setLoading(true);
    try {
      const params = { gallery_type: 'main' };
      if (category !== 'all') {
        params.category = category;
      }
      const response = await axios.get(`${API}/artworks`, { params });
      setArtworks(response.data);
    } catch (error) {
      console.error('Failed to fetch artworks:', error);
    } finally {
      setLoading(false);
    }
  };

  const setCategory = (cat) => {
    if (cat === 'all') {
      setSearchParams({});
    } else {
      setSearchParams({ category: cat });
    }
  };

  return (
    <div className="min-h-screen pt-32 pb-24" data-testid="gallery-page">
      <div className="max-w-[1600px] mx-auto px-6 md:px-12">
        <div className="text-center mb-16">
          <h1 className="font-serif text-5xl md:text-7xl tracking-tight leading-none mb-6" data-testid="gallery-title">
            Gallery
          </h1>
          <p className="text-base md:text-lg leading-relaxed text-muted-foreground mb-8">
            Browse our complete collection of original artworks
          </p>

          {/* Category Filter */}
          <div className="flex justify-center gap-4 flex-wrap">
            <Button
              variant={category === 'all' ? 'default' : 'outline'}
              onClick={() => setCategory('all')}
              className="rounded-full px-6 uppercase tracking-widest text-xs"
              data-testid="filter-all-btn"
            >
              ALL
            </Button>
            <Button
              variant={category === 'painting' ? 'default' : 'outline'}
              onClick={() => setCategory('painting')}
              className="rounded-full px-6 uppercase tracking-widest text-xs"
              data-testid="filter-painting-btn"
            >
              PAINTINGS
            </Button>
            <Button
              variant={category === 'photography' ? 'default' : 'outline'}
              onClick={() => setCategory('photography')}
              className="rounded-full px-6 uppercase tracking-widest text-xs"
              data-testid="filter-photography-btn"
            >
              PHOTOGRAPHY
            </Button>
          </div>
        </div>

        {loading ? (
          <div className="text-center text-muted-foreground py-20">Loading artworks...</div>
        ) : artworks.length === 0 ? (
          <div className="text-center text-muted-foreground py-20" data-testid="no-artworks-message">
            No artworks found in this category.
          </div>
        ) : (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-x-8 gap-y-16" data-testid="artworks-grid">
            {artworks.map((artwork) => (
              <ArtworkCard key={artwork.id} artwork={artwork} />
            ))}
          </div>
        )}
      </div>
    </div>
  );
}